export const version = "ethers/5.4.1";
//# sourceMappingURL=_version.js.map